import { type ReactNode } from 'react';

interface OptionCardProps {
  variant: 'watch' | 'spar';
  eyebrow: string;
  title: ReactNode;
  description: string;
  cta: string;
  onSelect?: () => void;
}

export function OptionCard({ variant, eyebrow, title, description, cta, onSelect }: OptionCardProps) {
  return (
    <button type="button" className={`option-card option-card--${variant}`} onClick={onSelect}>
      <span className="option-card__eyebrow">{eyebrow}</span>
      <h2 className="option-card__title">{title}</h2>
      <p className="option-card__desc">{description}</p>
      <span className="option-card__cta">
        {cta}{' '}
        <span aria-hidden="true">→</span>
      </span>
    </button>
  );
}
